import { Box, Button, Stack } from '@mui/material';

interface BottomActionButtonsProps {
    handleSalvarRascunho?: () => void;
    handleEnviarAprovacao?: () => void;
    isFormValid?: boolean;
    handleCancelar?: () => void;
}

export default function BottomActionButtons({
    handleSalvarRascunho,
    handleEnviarAprovacao,
    isFormValid = true,
    handleCancelar
}: BottomActionButtonsProps): JSX.Element {
    return (
        <Stack direction='row' spacing={2} justifyContent='space-between' sx={{ pt: 2 }}>
            {handleCancelar && <Button
                variant='outlined'
                color='error'
                onClick={handleCancelar}
            >
                Cancelar
            </Button>}

            <Box sx={{ display: 'flex', gap: 2 }}>
                {
                    handleSalvarRascunho &&
                    <Button
                        variant='contained'
                        color='info'
                        onClick={handleSalvarRascunho}
                    >
                        Salvar Rascunho
                    </Button>}

                {
                    handleEnviarAprovacao &&
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={handleEnviarAprovacao}
                        disabled={!isFormValid}
                    >
                        Enviar para Aprovação
                    </Button>}
            </Box>
        </Stack>
    )
}
